// extracted by mini-css-extract-plugin
module.exports = {"Option":"RevisionSelect_Option__JSNJC","Date":"RevisionSelect_Date__r8U_Q","Version":"RevisionSelect_Version__qPvTb"};